import * as React from "react";
import { SectionShell } from "@/components/design-system/SectionShell";
import { ListPill } from "@/components/ui/list-pill";

const code = `import { ListPill } from "@/components/ui/list-pill";

const [selected, setSelected] = React.useState("shaw");

{vendors.map((v) => (
  <ListPill
    key={v.id}
    name={v.name}
    count={v.openOrders}
    active={selected === v.id}
    onClick={() => setSelected(v.id)}
  />
))}`;

const VENDORS = [
  { id: "shaw", name: "Shaw Industries", count: 12 },
  { id: "mohawk", name: "Mohawk", count: 5 },
  { id: "daltile", name: "Daltile", count: 0 },
];

function PreviewGroup() {
  const [selected, setSelected] = React.useState("shaw");
  return (
    <div className="flex max-w-sm flex-col gap-2">
      {VENDORS.map((v) => (
        <ListPill
          key={v.id}
          name={v.name}
          count={v.count}
          active={selected === v.id}
          onClick={() => setSelected(v.id)}
        />
      ))}
    </div>
  );
}

export function ListPillSection() {
  return (
    <SectionShell
      id="list-pill"
      title="List pill"
      description={
        <>
          Selectable row for a vertical entity list — the generalized form of
          FloorCore's VendorPill. The active row fills with ink and its count
          badge turns accent, so the current selection reads at a glance.
        </>
      }
      whenToUse={
        <ul>
          <li>
            The list side of a master–detail layout (pick an entity, detail
            renders beside it).
          </li>
          <li>Entity filters where a per-entity count matters.</li>
        </ul>
      }
      whenNotToUse={
        <ul>
          <li>
            Tabular records with multiple columns — use{" "}
            <code>&lt;DataTable&gt;</code>.
          </li>
          <li>Small inline filters — use toggle buttons.</li>
          <li>Navigation menus — use the sub-navigation pattern.</li>
        </ul>
      }
      preview={<PreviewGroup />}
      code={code}
      options={
        <ul className="list-disc pl-5">
          <li>
            <code>count</code> is optional — omit it for a plain selectable
            row.
          </li>
          <li>
            <code>active</code> drives the filled state and is mirrored to{" "}
            <code>aria-pressed</code>.
          </li>
          <li>
            Extends <code>button</code> props, so <code>onClick</code>,{" "}
            <code>disabled</code>, etc. pass straight through.
          </li>
        </ul>
      }
    />
  );
}
